import { render, staticRenderFns } from "./SiteNavItem.vue?vue&type=template&id=78074cf3&scoped=true&"
import script from "./SiteNavItem.vue?vue&type=script&lang=js&"
export * from "./SiteNavItem.vue?vue&type=script&lang=js&"
import style0 from "./SiteNavItem.vue?vue&type=style&index=0&id=78074cf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78074cf3",
  null
  
)

export default component.exports